export default {
    isLogged:(state) => state.user != null && state.token != null,
    user: (state) => state.user,
    accessLevels: (state) => state.accessLevels,
    listEmployees: (state) => state.listEmployees,
    permissions: (state) => state.permissions,
    // modules: (state) => state.modules,
    // employeeHere: (state) => state.accessLevel
}
